export enum PopupType {
    SEARCH = <any>'S',
    ADD = <any>'A',
    RATE = <any>'R'
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/property-popup-type.enum.ts